'use client';

import React from 'react';
import {
    Container,
    Title,
    Text,
    Stack,
    Box,
} from '@mantine/core';
import { useResponsive } from '@/hooks/use-responsive';

const TermsOfService = () => {
    const { responsive } = useResponsive();

    return (
        <Box
            component="main"
            py={responsive({
                xs: 30,
                sm: 40,
                md: 50
            })}
        >
            <Container size="xl">
                <Stack gap={responsive({
                    xs: 'md',
                    sm: 'lg',
                    md: 'xl'
                })}>
                    <Title
                        order={1}
                        ta="center"
                        mt={responsive({
                            xs: 60,
                            sm: 80,
                            md: 100
                        })}
                        mb={responsive({
                            xs: 40,
                            sm: 60,
                            md: 80
                        })}
                        fz={responsive({
                            xs: 24,
                            sm: 28,
                            md: 32
                        })}
                    >
                        Terms of Service
                    </Title>

                    <Stack gap={responsive({
                        xs: 'sm',
                        sm: 'md',
                        md: 'lg'
                    })}>
                        <Text
                            fw={700}
                            fz={responsive({
                                xs: 16,
                                sm: 18,
                                md: 20
                            })}
                        >
                            HomeHealth Solutions Inc. Website Legal Terms and Disclaimer
                        </Text>

                        <Text fz={responsive({
                            xs: 14,
                            sm: 15,
                            md: 16
                        })}>
                            IMPORTANT! YOUR ACCESS TO THIS WEBSITE IS SUBJECT TO LEGALLY BINDING TERMS AND CONDITIONS.
                            CAREFULLY READ ALL OF THE FOLLOWING TERMS AND CONDITIONS BEFORE PROCEEDING.
                        </Text>

                        <Box>
                            <Text
                                fw={600}
                                mb="xs"
                                fz={responsive({
                                    xs: 15,
                                    sm: 16,
                                    md: 18
                                })}
                            >
                                1. Ownership and Copyright
                            </Text>
                            <Text fz={responsive({
                                xs: 14,
                                sm: 15,
                                md: 16
                            })}>
                                You acknowledge that any and all information, content, reports, data, databases, graphics,
                                interfaces, web pages, condominium documents, real estate documents, text, files, software,
                                product names, company names, trade-marks, logos and trade-names contained on this website,
                                (collectively the &ldquo;Content&rdquo;), including the manner in which the Content is presented or appears
                                and all information relating thereto, are the property of their respective owners as indicated,
                                the Company or its licensors, as the case may be.
                            </Text>
                        </Box>

                        <Box>
                            <Text
                                fw={600}
                                mb="xs"
                                fz={responsive({
                                    xs: 15,
                                    sm: 16,
                                    md: 18
                                })}
                            >
                                2. Permitted Use
                            </Text>
                            <Text fz={responsive({
                                xs: 14,
                                sm: 15,
                                md: 16
                            })}>
                                The Company hereby grants to You a personal, non-transferable and non-exclusive licence to
                                access, read and download one copy of the Content.
                            </Text>
                        </Box>

                        <Box>
                            <Text fw={600} mb="xs">3. Restrictions On Use</Text>
                            <Text>
                                You agree that You will not distribute the Content for any purpose, including, without
                                limitation, compiling an internal database, redistributing or reproducing the Content by
                                way of the press or media or through any commercial network, cable or satellite system.
                            </Text>
                        </Box>

                        <Box>
                            <Text fw={600} mb="xs">4. License to Use Your Information</Text>
                            <Text>
                                With the exception of personal information, You hereby grant to the Company the perpetual,
                                unlimited, royalty-free, worldwide, non-exclusive, irrevocable, transferable license to run,
                                display, copy, reproduce, publish, bundle, distribute, market, create derivative works of,
                                adapt, translate, transmit, arrange, modify, sublicense, export, merge, transfer, loan, rent,
                                lease, assign, share, outsource, host, make available to any person or otherwise use any
                                information or other content You provide on or through this website.
                            </Text>
                        </Box>

                        <Box>
                            <Text fw={600} mb="xs">5. Personal Information</Text>
                            <Text>
                                The Company may from time to time, but is not obligated to, monitor your use of the website
                                and collect, store, use personal information about You, and You hereby consent to such
                                collection, storage, use and disclosure and waive any right of privacy You may have.
                            </Text>
                            <Text mt="xs" fw={500} c="blue">
                                YOU MAY ACCESS, CORRECT AND DELETE YOUR OWN PERSONAL INFORMATION STORED BY COMPANY BY
                                EMAILING INFO@HOMEHEALTHSOLUTIONS.IO
                            </Text>
                        </Box>

                        <Box>
                            <Text fw={600} mb="xs">6. Limitations on Liability and Disclaimers</Text>
                            <Text>
                                THERE IS NO GUARANTEE THAT PERSONAL INFORMATION AND TRANSACTIONS ON THIS WEBSITE OR ON THE
                                INTERNET WILL BE MAINTAINED CONFIDENTIAL AND SECURE. THE USE OF THIS WEBSITE AND THE CONTENT
                                IS AT YOUR OWN RISK, AND THE COMPANY ASSUMES NO LIABILITY OR RESPONSIBILITY PERTAINING TO
                                THE CONTENT, YOUR USE OF THE WEBSITE OR THE RECEIPT, STORAGE, TRANSMISSION OR OTHER USE OF
                                YOUR PERSONAL INFORMATION.
                            </Text>
                        </Box>

                        <Box>
                            <Text
                                fw={600}
                                mb="xs"
                                fz={responsive({
                                    xs: 15,
                                    sm: 16,
                                    md: 18
                                })}
                            >
                                14. Enurement
                            </Text>
                            <Text fz={responsive({
                                xs: 14,
                                sm: 15,
                                md: 16
                            })}>
                                This Agreement shall inure to the benefit of and be binding upon each of us and our
                                respective successors and permitted assigns. You acknowledge having read this Agreement
                                before accepting it, having the authority to accept this Agreement and having received
                                a copy of this Agreement.
                            </Text>
                        </Box>

                        <Text
                            ta="center"
                            fw={500}
                            mt={responsive({
                                xs: 40,
                                sm: 60,
                                md: 80
                            })}
                            mb={responsive({
                                xs: 20,
                                sm: 30,
                                md: 40
                            })}
                            fz={responsive({
                                xs: 14,
                                sm: 15,
                                md: 16
                            })}
                        >
                            © <a href='https://www.homehealthsolutions.io' target='_blank' rel='noopener noreferrer'>HomeHealth Solutions Inc.</a>, {new Date().getFullYear()}, Calgary, Alberta.
                        </Text>
                    </Stack>
                </Stack>
            </Container>
        </Box>
    );
};

export default TermsOfService; 